export const DOM_NODES_IDS = {
  EDIT_FORM_TABLE_ROW_DRAG_HANDLER: (rowId: string) =>
    `EDIT_FORM_TABLE_ROW_DRAG_HANDLER-${rowId}`,
};
